<template>
  <div>
    <v-row align="center" style="margin: 20px">
      <v-col class="d-flex" cols="12" sm="12" lg="4">
        <span>جنسیت</span>
        <v-select
          :items="jensiatItems"
          item-text="text"
          item-value="value"
          v-model="jens"
        ></v-select>
      </v-col>
      <v-col class="d-flex" cols="12" sm="12" lg="4">
        <span>سطح</span>
        <v-select
          :items="sathItems"
          item-text="text"
          item-value="value"
          v-model="sath"
        ></v-select>
      </v-col>
    </v-row>
    <div>
      <div v-if="isMobile">
        <app-majors
          v-for="index in filteredMajors.length"
          :key="index"
          :index="index - 1"
          :major="filteredMajors[index - 1]"
          :selectedIndex="selectedIndex"
          @clicked="onClickMajor"
          :showDetails="showDetails"
        >
        </app-majors>
      </div>
      <div v-else>
        <v-data-table
          :items="filteredMajors"
          :headers="majorsHeaders"
          item-key="serial"
          class="elevation-1 rounded"
          show-expand
          single-expand
          :no-data-text="tableText"
          :item-class="rowClass"
          :footer-props="{
            itemsPerPageAllText: 'همه',
            itemsPerPageText: 'تعداد ردیف',
          }"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <b>توضيحات: </b>
              <span v-html="item.description"></span>
              <br />
            </td>
          </template>
          <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
            از {{ pageStart }} تا {{ pageStop }}
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>
<script>
import { getAllMajors } from "@/api/aboutus";
import MajorsApp from "./MajorsApp";

export default {
  components: {
    appMajors: MajorsApp,
  },
  data() {
    return {
      jensiatItems: [
        { value: "3", text: "-همه موارد-" },
        { value: "1", text: "برادران" },
        { value: "2", text: "خواهران" },
      ],
      sathItems: [
        { value: "5", text: "-همه موارد-" },
        { value: "1", text: "سطح 1" },
        { value: "2", text: "سطح 2" },
        { value: "3", text: "سطح 3" },
        { value: "4", text: "سطح 4" },
      ],
      jens: "3",
      sath: "5",
      majorsHeaders: [
        {
          text: "نام رشته",
          value: "name",
          width: "55%",
        },
        {
          text: "سطح",
          value: "sath",
          width: "10%",
        },
        {
          text: "جنسیت",
          value: "jensiatString",
          width: "10%",
        },
        {
          text: "واحدعمومی",
          value: "vahedOmoomi",
          width: "10%",
        },
        {
          text: "واحدتخصصی",
          value: "vahedTakh",
          width: "10%",
        },
        { text: "توضیحات", value: "data-table-expand", width: "5%" },
      ],
      showModal: false,
      scrollY: 0,
      selectedIndex: -1,
      showDetails: false,
      majors: [],
    };
  },
  computed: {
    filteredMajors() {
      let filteredMajors = [];
      if (Array.isArray(this.majors) && this.majors.length > 0) {
        filteredMajors = this.majors.filter((major) => {
          if (this.jens === "3" && this.sath === "5") {
            return major.jensiat != "3";
          } else if (this.jens === "3") {
            return major.jensiat != "3" && major.sath === this.sath;
          } else if (this.sath === "5") {
            return major.jensiat === this.jens;
          } else {
            return major.jensiat === this.jens && major.sath === this.sath;
          }
        });
      }
      return filteredMajors;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  created() {
    this.getAllMajors();
  },
  methods: {
    hideModal() {
      this.showModal = false;
    },
    getAllMajors() {
      getAllMajors()
        .then((response) => {
          const data = response.data;
          if (data && data.MajorsList) this.majors = data.MajorsList;
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    rowClass(item) {
      let rowClass = item.description === "" ? "no-expand" : "";
      return rowClass;
    },
    onClickMajor(index) {
      this.$store.commit("SET_SNACKBAR_SHOW", false);
      this.selectedIndex = index;
      if (this.majors[this.selectedIndex].description === "") {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "جزییاتی برای نمایش وجود ندارد."
        );
        this.showDetails = false;
      } else {
        this.showDetails = true;
      }
    },
  },
};
</script>
<style>
.directionLTR {
  direction: ltr;
}
</style>
